<div class="flex min-h-target items-center justify-between gap-3 pt-0.5" data-test="header-compact">
  <p class="min-w-0 truncate text-body font-semibold text-vw-ink first-letter:uppercase">{{ date | vwDate: 'long' }}</p>
  @if (guest) {
    <button type="button" data-test="header-signin" (click)="handleSignin()"
      class="flex min-h-target shrink-0 items-center rounded-pill px-3.5 text-body-s font-semibold text-vw-primary ring-2 ring-inset ring-vw-primary active:bg-vw-surface-tint">
      {{ 'home.header.signin' | translate }}
    </button>
  } @else {
    <button type="button"
      class="header-bell relative flex h-target w-target shrink-0 items-center justify-center rounded-pill border border-vw-line bg-vw-surface text-vw-primary-ink active:bg-vw-surface-sunk"
      [attr.aria-label]="(unreadCount() > 0 ? 'home.header.alerts-unread' : 'home.header.alerts') | translate: { count: unreadCount() }"
      (click)="handleBell()">
      <vw-bell-icon class="h-5 w-5" aria-hidden="true"></vw-bell-icon>
      @if (unreadCount() > 0) {
        <span class="absolute right-2 top-2 h-2.5 w-2.5 rounded-pill bg-vw-danger ring-2 ring-vw-surface" aria-hidden="true"></span>
      }
    </button>
  }
</div>
